import React from 'react';
import styled from 'styled-components';

import { Text as BaseText, Box } from 'Components/Base';

const HorizontalDivider = styled(Box)`
  border-bottom: 1px solid ${({ theme }) => theme.colors.greyscale.grey4};
  width: auto;
`;

const Text = styled(BaseText)`
  text-overflow: ellipsis;
  overflow: hidden;
`;

const FeedbackOption = ({ label, value, disabled, index }) => {
  const shouldShowDivider = disabled && index !== 0;
  return (
    <Box width={1}>
      {shouldShowDivider && <HorizontalDivider mx={4} />}
      <Text py={3} px={'21px'} fontSize={disabled ? 0 : 1} color={disabled ? 'info' : 'text'}>
        {label}
      </Text>
    </Box>
  );
};

export default FeedbackOption;
